export const SET_USERS = "SET_USERS";
export const SET_USER_ROLES = "SET_USER_ROLES";
export const REMOVE_USERS = "REMOVE_USERS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const FLUSH_AUTH = "FLUSH_AUTH";
